<template>
    <header class="page-header variant-9 sticky always">

        <div class="header-top-row">
            <div class="container">
                <div class="header-top-left">
                    <div class="header-custom-text">
                        <ul class="social-list-simple small">
                            <li>
                                <a href="https://www.facebook.com/hassustore/" target="_blank"
                                    class="icon icon-facebook-logo facebook">
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="header-custom-text">
                        <span><i class="icon icon-phone"></i> m.me/hassustore</span>
                        <span class="hidden-xs"><i class="icon icon-location"></i> www.hassu.pt</span>
                    </div>
                </div>
                <div class="header-top-right">
                    <!-- Header Links -->
                    <div class="header-links">
                        <!-- Header Language -->
                        <div class="header-link header-select dropdown-link header-language">
                            <a href="#"><img src="" alt /></a>
                            <ul class="dropdown-container" style="z-index: 9999;">
                                <li class="">
                                    <a href=""><img src="" alt /></a>
                                </li>
                            </ul>
                        </div>
                        <!-- /Header Language -->
                    </div>
                    <!-- /Header Links -->
                </div>
            </div>
        </div>

        <!-- Navbar -->
        <div class="navbar">
            <div class="container">
                <!-- Menu Toggle -->
                <div class="menu-toggle"><a href="#" class="mobilemenu-toggle"><i class="icon icon-menu"></i></a></div>
                <!-- /Menu Toggle -->
                <div class="header-right-links">
                    <div class="collapsed-links-wrapper no-login">
                        <div class="collapsed-links">
                            <div class="header-link dropdown-link header-cart header-account">
                                <a v-if="isAuthenticated()" @click="exit">
                                    <i class="fa fa-sign-out-alt" style="font-size: 19px;"></i>
                                    <span class="link-text"> Logout</span>
                                </a>
                                <a v-else @click="$router.push({name: 'Login'})">
                                    <i class="icon icon-user"></i>
                                    <span class="link-text">Login</span>
                                </a>
                            </div>

                        </div>
                    </div>
                    <!-- /Header Search -->
                </div>
                <!-- Logo -->
                <div class="header-logo">
                    <a class="logo_big" href="" title="Logo">
                        <img src="https://www.flamingob2b.pt/templates/gk_storebox/images/favicon.ico" alt="Flamingo" />
                    </a>
                    <a class="logo_small" href="" title="Logo">
                        <img src="https://www.flamingob2b.pt/templates/gk_storebox/images/favicon.ico" alt="Flamingo" />
                    </a>
                </div>
                <!-- /Logo -->

                <!-- Mobile Menu -->
                <div class="mobilemenu dblclick">
                    <div class="mobilemenu-header">
                        <div class="title">MENU</div>
                        <a href="#" class="mobilemenu-toggle"></a>
                    </div>
                    <div class="mobilemenu-content">
                        <ul class="nav" v-if="isAuthenticated()">
                            <li class="nav" v-for="(item, k) in menu" :key="k">
                                <a style="cursor:pointer" @click="$router.push({name: item.route})">{{ item.label }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- / Mobile Menu -->

                <!-- Mega Menu -->
                <div class="megamenu fadein blackout">
                    <ul class="nav" v-if="isAuthenticated()">
                        <li class="nav" v-for="(item, k) in menu" :key="k">
                            <a style="cursor:pointer" @click="$router.push({name: item.route})">{{ item.label }}</a>
                        </li>
                    </ul>
                </div>
                <!-- /Mega Menu -->
            </div>
        </div>
    </header>
</template>

<script>

export default {
    name: "Header",
    data () {
        return {
            menu: [
                {
                    label: 'Clients',
                    route: 'ClientArea'
                },
                {
                    label: 'Vouchers',
                    route: 'VoucherArea'
                },
                {
                    label: 'Register Sale',
                    route: 'ClientSearch'
                }
            ]
        }
    },
    methods: {
        exit () {
            return this.logout()
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/layouts/Header.vue